module.exports = __webpack_public_path__ + "img/money.d369a6ea.png";